const ROOT = "audioViewer";
const INSERT_PLUGIN_MODAL = "audioModalEmbed";
const INSERT_PLUGIN_MODAL_TABS = "audioModalEmbedTabs";
const EMBED_TAB = "Embed_Tab";
const EMBED_TAB_URL_INPUT = "audioModalEmbedInput";
const EMBED_TAB_SUBMIT_BUTTON = "actionButtonSave";
const UPLOAD_TAB = "Upload_Tab";
const UPLOAD_TAB_UPLOAD_BUTTON = "AudioModalCustomUpload";
const AUDIO_SETTINGS_AUDIO_NAME_INPUT = "audioSettingsAudioNameInput";
const AUDIO_SETTINGS_AUTHOR_NAME_INPUT = "audioSettingsAuthorNameInput";
const AUDIO_COVER_IMAGE = "audioCoverImage";
const AUDIO_DOWNLOAD_TOGGLE = "AudioDownloadToggle";
const AUDIO_TITLE = "audioTitle";
const AUDIO_CREATOR = "audioCreator";
const AUDIO_SETTINGS_MODAL = "audioSettings";

export { AUDIO_COVER_IMAGE, AUDIO_CREATOR, AUDIO_DOWNLOAD_TOGGLE, AUDIO_SETTINGS_AUDIO_NAME_INPUT, AUDIO_SETTINGS_AUTHOR_NAME_INPUT, AUDIO_SETTINGS_MODAL, AUDIO_TITLE, EMBED_TAB, EMBED_TAB_SUBMIT_BUTTON, EMBED_TAB_URL_INPUT, INSERT_PLUGIN_MODAL, INSERT_PLUGIN_MODAL_TABS, ROOT, UPLOAD_TAB, UPLOAD_TAB_UPLOAD_BUTTON };
//# sourceMappingURL=dataHooks.js.map
